import type { ISerialize } from '@/objects/ISerialize';

export class SignalrContestantsUpdatedSubscribeParameters implements ISerialize {
    public EventID: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { EventID?: number }) {
        this.EventID = values.EventID ?? 0;
    }

    public serialize(): string {
        return '{' + `"EventID": ${JSON.stringify(this.EventID)}` + '}';
    }

    /**
     * Creates an instance of SignalrContestantsUpdatedSubscribeParameters from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { EventID?: number }): SignalrContestantsUpdatedSubscribeParameters {
        return new SignalrContestantsUpdatedSubscribeParameters(values);
    }

    public static _FromServerJson(json: any): SignalrContestantsUpdatedSubscribeParameters {
        return new SignalrContestantsUpdatedSubscribeParameters({ EventID: json.EventID });
    }

    /**
     * Creates an instance of SignalrContestantsUpdatedSubscribeParameters from another instance of SignalrContestantsUpdatedSubscribeParameters.
     * @param other The SignalrContestantsUpdatedSubscribeParameters you want to clone
     * @returns A cloned SignalrContestantsUpdatedSubscribeParameters
     */
    public static FromOther(other: SignalrContestantsUpdatedSubscribeParameters): SignalrContestantsUpdatedSubscribeParameters {
        return SignalrContestantsUpdatedSubscribeParameters._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SignalrContestantsUpdatedSubscribeParameters.FromOther(this);
    }

    static NAME_OF_CLASS = 'SignalrContestantsUpdatedSubscribeParameters';
}
